/* eslint-disable import/order */
import {
  Box,
  Button,
  Grid,
  makeStyles,
  MenuItem,
  Slide,
  TextField,
} from '@material-ui/core'
import AppBar from '@material-ui/core/AppBar'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import withStyles from '@material-ui/core/styles/withStyles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import styles from '../../../resources/theme/global'
import { edit, fetchBank, transfer, update } from '../BankActions'
import Form from './Form'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import colors from '../../../assets/colors'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import {
  mdiBankTransferIn,
  mdiBankTransferOut,
  mdiMenuDownOutline,
  mdiMenuUpOutline,
} from '@mdi/js'
import Icon from '@mdi/react'
import { exportFormatedMoney } from '../../../util/utils'
import InputNumberCustom from '../../../components/hooks/BaseInputNumber'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { format, startOfDay } from 'date-fns'

const useStyles = makeStyles({
  bankBox: {
    width: '100%',
    display: 'flex',
    border: `1px solid ${colors.graylight}`,
    borderRadius: '8px',
    color: colors.textGray,
    padding: '4px 8px',
    alignItems: 'center',
    gap: '12px',
  },
})

const BankTransfer = props => {
  const { classes } = props
  const dispatch = useDispatch()
  const defaultBanks = useSelector(state => state.bank.items)
  const styles = useStyles()
  const filterStyles = filterStylesComponents()

  const [entryBank, setEntryBank] = useState({})
  const [exitBank, setExitBank] = useState({})

  const entryBanks = useMemo(() => {
    return defaultBanks?.filter(bank => bank?.id != exitBank?.id)
  }, [defaultBanks, exitBank])

  const exitBanks = useMemo(() => {
    return defaultBanks?.filter(bank => bank?.id != entryBank?.id)
  }, [defaultBanks, entryBank])

  const [form, setForm] = useState({
    balance: '',
    actual_payment_date: new Date(),
  })

  const onClose = () => {
    props.history.push('/bank')
  }

  const handleSelectBank = e => {
    e.preventDefault()
    const { name: type, value: id } = e.target
    const bank = defaultBanks?.find(bnk => bnk?.id == id)
    if (type == 'entry_bank') return setEntryBank(bank)
    return setExitBank(bank)
  }

  const handleSubmit = async e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)
    const entries = data.entries()
    const values = Object.fromEntries(entries)

    const finalData = {
      ...values,
      balance: form?.balance,
      actual_payment_date: format(
        startOfDay(form.actual_payment_date),
        'yyyy-MM-dd HH:mm:ss'
      ),
    }

    try {
      const resp = await dispatch(transfer(finalData))
      if (resp) return onClose()
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    dispatch(fetchBank())
  }, [])

  return (
    <BaseFilterModal
      open
      handleOpen={onClose}
      title="Transferência Bancária"
      hiddenHelpButton
    >
      <Grid item xs={12} style={{ width: '420px' }}>
        <form onSubmit={handleSubmit}>
          <Grid
            container
            alignItems="center"
            justifyContent="flex-start"
            spacing={2}
          >
            <Grid item xs={12}>
              <Typography
                style={{ fontSize: '16px', fontWeight: 'normal' }}
                color={colors.primary}
              >
                Utilize os campos para realizar uma nova Transferência Bancária
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <Box className={styles.bankBox}>
                    <Icon path={mdiBankTransferOut} size={2} />

                    <Box
                      style={{
                        display: 'flex',
                        gap: '2px',
                        flexDirection: 'column',
                      }}
                    >
                      <Typography>Saldo do Banco de Saída </Typography>
                      <Typography
                        style={{
                          fontWeight: 'bold',
                          color:
                            exitBank?.balance && exitBank?.balance >= 0
                              ? colors.sucess
                              : colors.error,
                        }}
                      >
                        {exportFormatedMoney(exitBank?.balance)}
                      </Typography>
                      {form?.balance && (
                        <Typography
                          style={{
                            fontWeight: 'bold',
                            fontSize: '10px',
                            color: colors.error,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <Icon size={0.8} path={mdiMenuDownOutline} />
                          {exportFormatedMoney(-form?.balance)}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={6}>
                  <Box className={styles.bankBox}>
                    <Icon path={mdiBankTransferIn} size={2} />

                    <Box
                      style={{
                        display: 'flex',
                        gap: '2px',
                        flexDirection: 'column',
                      }}
                    >
                      <Typography>Saldo do Banco de Entrada </Typography>
                      <Typography
                        style={{
                          fontWeight: 'bold',
                          color:
                            entryBank?.balance && entryBank?.balance >= 0
                              ? colors.sucess
                              : colors.error,
                        }}
                      >
                        {exportFormatedMoney(entryBank?.balance)}
                      </Typography>
                      {form?.balance && (
                        <Typography
                          style={{
                            fontWeight: 'bold',
                            fontSize: '10px',
                            color: colors.sucess,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <Icon size={0.8} path={mdiMenuUpOutline} />
                          {exportFormatedMoney(form?.balance)}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <TextField
                    label="Banco de Saída"
                    value={exitBank?.id}
                    onChange={handleSelectBank}
                    select
                    required
                    name="exit_bank"
                    fullWidth
                  >
                    <MenuItem value="">Selecione</MenuItem>
                    {exitBanks?.map(bank => (
                      <MenuItem value={bank?.id} key={bank?.id}>
                        {bank?.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Banco de Entrada"
                    value={entryBank?.id}
                    onChange={handleSelectBank}
                    select
                    required
                    name="entry_bank"
                    fullWidth
                  >
                    <MenuItem value="">Selecione</MenuItem>
                    {entryBanks?.map(bank => (
                      <MenuItem value={bank?.id} key={bank?.id}>
                        {bank?.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12}>
                  <Grid
                    container
                    alignItems="center"
                    spacing={4}
                    justifyContent="center"
                  >
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="Valor da Transferência"
                        disabled={!entryBank?.id || !exitBank?.id}
                        helperText={
                          !entryBank?.id || !exitBank?.id
                            ? 'Selecione os bancos'
                            : 'Digite o valor'
                        }
                        onChange={e =>
                          setForm({ ...form, balance: e.floatValue })
                        }
                        name="balance"
                        required
                        InputProps={{
                          inputComponent: InputNumberCustom,
                          inputProps: {
                            prefix: 'R$ ',
                            allowNegative: false,
                            style: {
                              textAlign: 'center',
                              color: colors.textPrimary,
                            },
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <KeyboardDatePicker
                        clearable
                        value={form?.actual_payment_date}
                        label="Data do Pagamento"
                        fullWidth
                        clearLabel="Limpar"
                        helperText="Data do pagamento"
                        invalidDateMessage="Data inválida"
                        autoOk
                        onChange={date =>
                          setForm({ ...form, actual_payment_date: date })
                        }
                        maxDate={new Date('2300-01-01')}
                        format="dd/MM/yyyy"
                        required
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container justifyContent="flex-end">
                <Button
                  // disabled={isSubmitting}
                  // onClick={submitForm}
                  type="submit"
                  className={filterStyles.btnSalvar}
                >
                  Salvar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </BaseFilterModal>
  )
}

export default withStyles(styles)(BankTransfer)
